import { useMutation } from '@tanstack/react-query'

import { graphql } from '~/gql'
import { useGraphQLRequest } from '~/hooks/useGraphQLRequest'

import { useMainQueryStrategyMemo } from './useMainQuery'
import { useStrategyMemoId } from './useStrategyMemoId'

const document = graphql(`
  query StrategyMemoEditPage_GetStrategyMemoUpdatedAt($strategyMemoId: ID!) {
    customerStrategyMemo(id: $strategyMemoId) {
      updatedAt
    }
  }
`)

export const useCheckConflictMutation = (
  options: MutationOptions<boolean, void> = {},
) => {
  const graphQLRequest = useGraphQLRequest()
  const strategyMemoId = useStrategyMemoId()
  const strategyMemo = useMainQueryStrategyMemo()

  return useMutation({
    mutationFn: async () => {
      const result = await graphQLRequest({
        document,
        variables: { strategyMemoId },
      })

      return result.customerStrategyMemo?.updatedAt !== strategyMemo.updatedAt
    },
    ...options,
  })
}
